module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAVBAMAAABMGyhsAAAAMFBMVEUAAAB4eHiAgIB9fX2AgIB+fn59fX1+fn5+fn5/f39+fn59fX1+fn5+fn5+fn5+fn72T/zDAAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAAl0lEQVQY02Ow3o0CDBjO/0cBGxj+U0Pg9R4IczfI+P1AgQaGfBD/DwPz+/+/+YAChZ/595zd+3cXX8GbvSfkgQJOhSHK4qafw9mNEw3d/YECSu4L3nNNKHwqksP1uaQeKMDxf0MrzwPuL/X/2Sc09m9g+OPz/5u7/6P6L/P/t5RcuQ9zR9J76voFXWA/qsACBk2UIN2hAADfixTb+ZWN3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/f-pp.png
// module id = 752
// module chunks = 0